
import React from 'react'
import { get } from 'lodash';
import BrowseCell from '../Table/ButtonsCell/BrowseCell/BrowseCell';
import { truncateText } from '../../helpers/utils';
import ScoreCell from '../Table/ScoreCell/ScoreCell';
import { vehicleTypes } from '../../consts/vehicleTypes';

const SingleRow = (isMobile, vehicleType) => ((item) =>  {
  const formattedModel = truncateText(get(item, ['vehicle', 'model']), 17, 'right');
  const formattedCategory = truncateText(get(item, ['vehicle', 'category']), 17, 'right');

  const mobileCells =
    { [vehicleTypes.Motorbike]: [
        <td key="mobile-cells" className="cell-mobile-wrapper">
          <div>
            <span>{get(item, ['vehicle', 'brand_name'])} {formattedModel}</span>
          </div>
          <div>
            <span>{get(item, ['vehicle', 'year'])}, {get(item, 'hash_id')}</span>
          </div>
        </td>
      ],
      [vehicleTypes.AgriculturalMachine]: [
        <td key="mobile-cells" className="cell-mobile-wrapper">
          <div>
            <span>{get(item, ['vehicle', 'brand_name'])} {formattedCategory}</span>
          </div>
          <div>
            <span>{get(item, ['vehicle', 'production_year'])}, {get(item, 'hash_id')}</span>
          </div>
        </td>
      ],
      [vehicleTypes.Camper]: [
        <td key="mobile-cells" className="cell-mobile-wrapper">
          <div>
            <span>{get(item, ['vehicle', 'body_mark'])}, {formattedModel}</span>
          </div>
          <div>
            <span>{get(item, ['vehicle', 'year'])}, {get(item, 'hash_id')}</span>
          </div>
        </td>
      ], };

  const desktopCells =
    { [vehicleTypes.Motorbike]: [
      <td key="brand">{get(item, ['vehicle', 'brand_name'])}</td>,
      <td key="model" className="cell-model">
        {formattedModel}
      </td>,
      <td key="year">{get(item, ['vehicle', 'year'])}</td>,
      <td key="owners" className="cell-owners">{get(item, 'hash_id')}</td>,
      <td key="zip_code">{get(item, 'zip_code')}</td>,
      <td key="value" className="cell-bets">
        <BrowseCell
          hihestBetValue={get(item, 'value')}
          buyNowContract={get(item, 'buy_now_contract')}
          contractSent={get(item, 'contract_sent')}
        />
      </td>
    ],
    [vehicleTypes.AgriculturalMachine]: [
      <td key="brand">{get(item, ['vehicle', 'brand_name'])}</td>,
      <td key="model" className="cell-model">
        {formattedCategory}
      </td>,
      <td key="year">{get(item, ['vehicle', 'production_year'])}</td>,
      <td key="owners" className="cell-owners">{get(item, 'hash_id')}</td>,
      <td key="zip_code">{get(item, 'zip_code')}</td>,
      <td key="value" className="cell-bets">
        <BrowseCell
          hihestBetValue={get(item, 'value')}
          buyNowContract={get(item, 'buy_now_contract')}
          contractSent={get(item, 'contract_sent')}
        />
      </td>
    ],
    [vehicleTypes.Camper]: [
      <td key="brand">{get(item, ['vehicle', 'body_mark'])}</td>,
      <td key="model" className="cell-model">
        {formattedModel}
      </td>,
      <td key="year">{get(item, ['vehicle', 'year'])}</td>,
      <td key="owners" className="cell-owners">{get(item, 'hash_id')}</td>,
      <td key="zip_code">{get(item, 'zip_code')}</td>,
      <td key="value" className="cell-bets">
        <BrowseCell
          hihestBetValue={get(item, 'value')}
          buyNowContract={get(item, 'buy_now_contract')}
          contractSent={get(item, 'contract_sent')}
        />
      </td>
    ], };

  return [
    <ScoreCell
      key="score"
      score={get(item, ['vehicle', 'score'])}
      photo={get(item, 'photo')}
      model={get(item, ['vehicle', 'model'])}
    />
  ].concat(isMobile ? mobileCells[vehicleType] : desktopCells[vehicleType]);
})

export default SingleRow
